import { Pipe, PipeTransform } from '@angular/core';

import { ChatMemberInfo } from '../chat.models';

@Pipe({
  name: 'userStatus',
})
export class UserStatusPipe implements PipeTransform {
  transform(chatMemberInfo: ChatMemberInfo[]): string | undefined {
    if (!chatMemberInfo?.length) {
      return undefined;
    }

    return chatMemberInfo.find((member) => !!member.statusColor)?.statusColor;
  }
}
